module.exports = __webpack_public_path__ + "fonts/Latinka-LightItalic.52858567.ttf";